import { render } from "./App.vue?vue&type=template&id=2c45e424"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2c45e424&lang=css"

import exportComponent from "C:\\servers\\develope\\arbitrage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__